/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Design_Settings_ResetInputs */

const en_admin_design_settings_reset = /** @type {(inputs: Admin_Design_Settings_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset`)
};

const de_admin_design_settings_reset = /** @type {(inputs: Admin_Design_Settings_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurücksetzen`)
};

/**
* | output |
* | --- |
* | "Reset" |
*
* @param {Admin_Design_Settings_ResetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_design_settings_reset = /** @type {((inputs?: Admin_Design_Settings_ResetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Design_Settings_ResetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_design_settings_reset(inputs)
	return en_admin_design_settings_reset(inputs)
});